import React from 'react'

const Info = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3334 9.99996C18.3334 5.39758 14.6024 1.66663 10 1.66663C5.39765 1.66663 1.66669 5.39758 1.66669 9.99996C1.66669 14.6023 5.39765 18.3333 10 18.3333C14.6024 18.3333 18.3334 14.6023 18.3334 9.99996Z" stroke="#2F3237" strokeWidth="1.5"/>
    <path d="M10.2018 14.1666V9.99996C10.2018 9.60713 10.2018 9.41071 10.0797 9.28863C9.95772 9.16663 9.7613 9.16663 9.36847 9.16663" stroke="#2F3237" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.99329 6.66663H10.0008" stroke="#2F3237" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
  )
}

export default Info
